import axios from "axios";

export const getIdfromEmail = (username: string, token: string | null) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}forget/password`, {
      params: {
        login: `${username}`,
        token: `${token}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
